import { forwardRef, type PropsWithChildren } from 'react';
import { useClickAway } from 'react-use';

import { GlobalHeaderButtons } from '~/modules/global-search/components/SearchWrapper/GlobalHeaderButtons';

import { useGlobalSearchContext } from '../../hooks/useGlobalSearchContext';
import { SearchField } from '../SearchField';
import { SearchResults } from '../SearchResults';
import { PageOverlay } from './PageOverlay';

export const SearchWrapper = forwardRef<HTMLDivElement, PropsWithChildren>(
  ({ children }, ref) => {
    const { searchQuery, resetSearch } = useGlobalSearchContext();

    useClickAway(ref as React.RefObject<HTMLDivElement>, () => {
      resetSearch();
    });

    return (
      <div className="flex h-dvh min-w-0 flex-1 flex-col">
        <div className="grid grid-cols-[1fr_min-content] justify-items-center gap-sm px-xl py-md">
          <div ref={ref} className="relative w-full max-w-[37.5rem]">
            <SearchField />
            {searchQuery ? <SearchResults /> : null}
          </div>
          <GlobalHeaderButtons />
        </div>
        <div className="relative flex flex-1 flex-col overflow-y-auto">
          {children}
          <PageOverlay />
        </div>
      </div>
    );
  },
);

SearchWrapper.displayName = 'SearchWrapper';
